<template>
    <div>
        <div>
            <div class="main-inner" v-permission:manage_projects="currentUser">
                <div class="row">
                    <div class="col-12 col-xl-4 d-flex flex-column">
                        <Welcome></Welcome>
                        <Diskspace class="widget--stretch"></Diskspace>
                    </div>

                    <div class="col-12 col-xl-4 d-flex flex-column">
                        <InspectionStatus class="widget--stretch"></InspectionStatus>
                    </div>

                    <div class="col-12 col-xl-4 d-flex flex-column">
                        <Statistics class="widget--stretch"></Statistics>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-xl-4">
                        <LatestProjects></LatestProjects>
                    </div>

                    <div class="col-12 col-xl-8">
                        <Notifications></Notifications>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Welcome from '@/components/widgets/Welcome.vue'
    import Diskspace from '@/components/widgets/Diskspace.vue'
    import Statistics from '@/components/widgets/Statistics.vue'
    import InspectionStatus from '@/components/widgets/InspectionStatus.vue'
    import LatestProjects from '@/components/widgets/LatestProjects.vue'
    import Notifications from '@/components/widgets/Notifications.vue'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            Welcome,
            Diskspace,
            InspectionStatus,
            Statistics,
            LatestProjects,
            Notifications,
        },

        computed: {
            ...mapGetters([
                'currentUser',
            ]),
        }
    }
</script>